export const columns = [
  { field: 'name', label: 'Name' },
  // { field: 'requested_id', label: 'Requested ID' },
  { field: 'submission_date', label: 'Submission Date' },
  {field: 'approval_status', label: 'Status' },
  { field: 'action', label: 'Approve/Reject' }
]

export const rows = [
  {
    id: "123",
    name: "Rutuja Patil",
    requested_id: "REQ001",
    submission_date: "2025-06-01",
    approval_status: "Pending",
  },
   {
    id: "123",
    name: "Rutuja Patil",
    requested_id: "REQ001",
    submission_date: "2025-06-01",
    approval_status: "Pending",
  },
    {
    id: "123",
    name: "Rutuja Patil",
    requested_id: "REQ001",
    submission_date: "2025-06-01",
    approval_status: "Pending",
  },
    {
    id: "123",
    name: "Rutuja Patil",
    requested_id: "REQ001",
    submission_date: "2025-06-01",
    approval_status: "Pending",
  },
    {
    id: "123",
    name: "Rutuja Patil",
    requested_id: "REQ001",
    submission_date: "2025-06-01",
    approval_status: "Pending",
  },
];



